import { ArrowRight, ShieldCheck } from "lucide-react";
import { useNavigate } from "react-router-dom";

import { ColocaButton } from "@/shared/components/buttons/ColocaButton";
import useTranslations from "@/shared/lang/useTranslations";

import { AuthShell } from "../components/AuthShell";

export const ResetSuccessPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslations("login");

  return (
    <AuthShell>
      <div className="flex flex-col items-center w-full max-w-md mx-auto text-center">
        <div className="flex flex-col items-center gap-5 mb-8 animate-fade-down">
          <div className="relative">
            <div className="absolute inset-0 bg-primary/20 rounded-full blur-xl animate-pulse" />
            <div className="relative bg-primary/15 p-4 rounded-full">
              <ShieldCheck className="w-10 h-10 text-primary" />
            </div>
          </div>
          <div className="space-y-2">
            <h2 className="text-2xl font-bold text-foreground">{t("fp_done_title")}</h2>
            <p className="text-sm text-muted-foreground max-w-sm">{t("fp_done_subtitle")}</p>
          </div>
        </div>

        <ColocaButton
          variant="primary"
          size="lg"
          onClick={() => navigate("/auth/login")}
          className="h-12 w-full max-w-xs text-base font-semibold"
          iconTrailing={ArrowRight}
        >
          {t("fp_done_go_login")}
        </ColocaButton>
      </div>
    </AuthShell>
  );
};

export default ResetSuccessPage;
